import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TaskComments from "../task/TaskComments";
import TaskActivityStream from "./TaskActivity";
import SubTask from "./SubTask";
import TaskIssue from "./TaskIssues";
import TaskDocument from "./TaskDocument";
import TaskLogHour from "./TaskLogHour";
import { fetchEntityById,} from "../../../apis/apiService";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchTaskActivityQuery,
  useFetchTaskDetailViewQuery,
} from "../../../slice/logdetailSlice";
import { CommonTaskDetail } from "../../common/Task/CommonTaskDeatil";
import { TaskBudget } from "./TaskBudget";


export const SubTaskTabs = ({
  taskid,
  login_user_name,
  login_user_id,
  selectedUser,
  owners,
  login_user_role,
  document_count,
  comment_count,
  logHours,
  refetch,
}) => {
  const { id, name } = useParams();
  const isOwner = owners?.some((owner) => owner.user_id === login_user_id);
  // console.log("user_listsss :", selectedUser, login_user_id);
  // // console.log("user_listsss :", owner_name, login_user_name);

  const [issueCount, setIssueCount] = useState(0);

  // const [subtaskCount, setSubtaskCount] = useState(0);

  // useEffect(() => {
  //   const fetchSubtaskCount = async () => {
  const [subtasks, setSubtasks] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSubtasks = async (isSilent = false) => {
    if (!isSilent) setLoading(true);
    try {
      const data = await fetchEntityById("task/subtask", taskid);
      if (data && data.subtasks) {
        // setSubtaskCount(data.subtasks.length);
        const formattedTasks = data.subtasks.map((item) => ({
          ...item,
          id: item.id || item.task_id,
        }));
        setSubtasks(formattedTasks);
      }
    } 
    catch (error) {
      // console.error("Failed to fetch subtasks count:", error);
      console.error("Failed to fetch subtasks:", error);
    } 
    finally {
      if (!isSilent) setLoading(false);
    }
  };

  useEffect(() => {
    if (taskid) {
      // fetchSubtaskCount();
      fetchSubtasks();
    }
  }, [taskid]);

  const subtaskCount = subtasks.length;

  return (
    <div className=" ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <button
            className=" active text-rgba-gray R_btn"
            id="Comments-tab"
            data-bs-toggle="tab"
            data-bs-target="#Comments"
            type="button"
            role="tab"
            aria-controls="Comments"
            aria-selected="true"
          >
            Comments ({comment_count})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Subtasks-tab"
            data-bs-toggle="tab"
            data-bs-target="#Subtasks"
            type="button"
            role="tab"
            aria-controls="Subtasks"
            aria-selected="false"
          >
            {/* Subtasks */}
            Subtasks ({subtaskCount})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className="text-rgba-gray R_btn"
            id="LogHours-tab"
            data-bs-toggle="tab"
            data-bs-target="#LogHours"
            type="button"
            role="tab"
            aria-controls="LogHours"
            aria-selected="false"
          >
            {/* {["ADMIN", "MANAGER"].includes(login_user_role) || // ✅ Always show for Admin & Manager
            login_user_role === "CLIENT" ||
            selectedUser === login_user_id ||
            owner_name === login_user_name ? (
              <div>Log Hours</div>
            ) : null} */}
            {["ADMIN", "MANAGER"].includes(login_user_role) ||
            login_user_role === "CLIENT" ||
            selectedUser === login_user_id ||
            isOwner ? (
              <div>Log Hours ({logHours})</div>
            ) : null}
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Documents-tab"
            data-bs-toggle="tab"
            data-bs-target="#Documents"
            type="button"
            role="tab"
            aria-controls="Documents"
            aria-selected="false"
          >
            Documents ({document_count})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Issues-tab"
            data-bs-toggle="tab"
            data-bs-target="#Issues"
            type="button"
            role="tab"
            aria-controls="Issues"
            aria-selected="false"
          >
            Issues ({issueCount})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="ActivityStream-tab"
            data-bs-toggle="tab"
            data-bs-target="#ActivityStream"
            type="button"
            role="tab"
            aria-controls="ActivityStream"
            aria-selected="false"
          >
            Activity Stream
          </button>
        </li>

        {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
          <li className="nav-item pe-4" role="presentation">
            <button
              className=" text-rgba-gray R_btn"
              id="taskbudget-tab"
              data-bs-toggle="tab"
              data-bs-target="#taskbudget"
              type="button"
              role="tab"
              aria-controls="taskbudget"
              aria-selected="false"
            >
              Budget
            </button>
          </li>
        )}
      </ul>

      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="Comments"
          role="tabpanel"
          aria-labelledby="Comments-tab"
        >
          <TaskComments />
        </div>

        <div
          className="tab-pane fade"
          id="Subtasks"
          role="tabpanel"
          aria-labelledby="Subtasks-tab"
        >
          <SubTask 
            subtasklist={subtasks} 
            fetchSubtasklist={fetchSubtasks} 
          />
        </div>

        <div
          className="tab-pane fade"
          id="LogHours"
          role="tabpanel"
          aria-labelledby="LogHours-tab"
        >
          {/* <TaskLogHour /> */}
          <TaskLogHour parentRefetch={refetch} />
        </div>

        <div
          className="tab-pane fade"
          id="Documents"
          role="tabpanel"
          aria-labelledby="Documents-tab"
        >
          <TaskDocument taskid={taskid} />
        </div>

        <div
          className="tab-pane fade"
          id="Issues"
          role="tabpanel"
          aria-labelledby="Issues-tab"
        >
          <TaskIssue setIssueCount={setIssueCount} />
        </div>

        <div
          className="tab-pane fade"
          id="ActivityStream"
          role="tabpanel"
          aria-labelledby="ActivityStream-tab"
        >
          <TaskActivityStream />
        </div>

        {(login_user_role === "ADMIN" ||
          login_user_role === "MANAGER") && (
          <div
            className="tab-pane fade"
            id="taskbudget"
            role="tabpanel"
            aria-labelledby="taskbudget-tab"
          >
            <TaskBudget current_id={taskid} />
          </div>
        )}
      </div>
    </div>
  );
};

const TaskDetail = () => {
  const { id } = useParams();
  const { project_id } = useParams();

  const [loading, setLoading] = useState(false);
  // const { data: project_based_users, refetch: project_based_users_refetch } =
  //   useFetchGetAllProjectBasedUserNameListQuery(project_id);
  const {
    data: project_based_users,
    refetch: project_based_users_refetch,
    isUninitialized: isPBUUninitialized,
    isLoading: isPBULoading,
  } = useFetchGetAllProjectBasedUserNameListQuery(project_id);
  // console.log("Task_list_id: ", tasklist_id);

  const navigate = useNavigate();

  const {
    data: task_view,
    isLoading,
    refetch,
    isUninitialized: isTaskViewUninitialized,
  } = useFetchTaskDetailViewQuery(id);
  const {
    refetch: task_activity_status,
    isUninitialized: isTaskActivityUninitialized,
    isLoading: isTaskActivityLoading,
  } = useFetchTaskActivityQuery(id);

  // Safe refetch helper to avoid "Cannot refetch a query that has not been started yet"
  const safeRefetch = (fn, isUninitialized, isLoadingState, label) => {
    if (typeof fn === "function" && !isUninitialized && !isLoadingState) {
      try {
        fn();
      } 
      catch (e) {
        console.debug(`Safe refetch guard handled early call in TaskDetail: ${label}`);
      }
    }
  };

  const handleBoxClick = async (taskId) => {
    setLoading(true); // Start loading

    try {
      navigate(`/projects/projectDetail/${project_id}/taskdetail/${taskId}`);
      // await refetch(); // Ensure refetch completes before stopping loading
    } 
    catch (error) {
      console.error("Error fetching task details:", error);
    } 
    finally {
      setLoading(false); // Stop loading
    }
  };
  // useEffect(() => {
  //   refetch();
  // }, [id]);
  return (
    <>
      <CommonTaskDetail
        project_id={project_id}
        id={id}
        handleBoxClick={handleBoxClick}
        showPath="tasklist/show"
        updatePath="task"
        // refetch={refetch}
        refetch={() => safeRefetch(refetch, isTaskViewUninitialized, isLoading, "task_view")}
        task_view={task_view}
        isLoading={isLoading}
        project_based_users={project_based_users}
        // project_based_users_refetch={project_based_users_refetch}
        // task_activity_status={task_activity_status}
        project_based_users_refetch={() => safeRefetch(project_based_users_refetch, isPBUUninitialized, isPBULoading, "project_based_users")}
        task_activity_status={() => safeRefetch(task_activity_status, isTaskActivityUninitialized, isTaskActivityLoading, "task_activity")}
        istaskDetail={true}
      />
    </>
  );
};

export default TaskDetail;
